<div
  #header
  class="header container-fluid"
  [class.b-shadow]="!isTop()"
  [ngClass]="{
    'header-in-scroll': inScroll,
    'header-shop-page-in-scroll': isShopRelatedPage && inScroll,
  }"
>
  <app-country-popup></app-country-popup>
  <div class="container-fluid header--section-banner">
    <app-top-banner></app-top-banner>
  </div>
  <div class="header--section-top" *ngIf="!inScroll" [@slideUpFade]>
    <app-top-links [baseId]="baseId"></app-top-links>
  </div>
  <div
    class="header--section-mid"
    [class.max-width]="inScroll"
    [ngClass]="{
      'horizontal-spacing': inScroll,
      'pb-0': isShopRelatedPage && inScroll && !isDesktop,
    }"
  >
    <div
      class="row align-items-center"
      [ngClass]="{ 'mobile-alignment desktop-alignment': inScroll }"
    >
      <div
        class="d-flex min-width-max-content"
        [ngClass]="{ 'col-6 col-lg-3 flex-1-0': !isComponentInitiated || !inScroll }"
      >
        <div class="d-flex align-items-center">
          <div class="header--burger d-lg-none" *ngIf="!sideMenuToggled">
            <app-svg
              [attr.data-qa]="burgerButtonId?.getButtonId()"
              iconName="Burger"
              (click)="toggleSideMenu()"
              (keydown.enter)="toggleSideMenu()"
              dimension="1.5rem"
            ></app-svg>
          </div>
          <button
            class="btn-clean d-lg-none close-icon"
            (click)="onCloseSearch()"
            *ngIf="sideMenuToggled"
          >
            <app-svg dimension="1.25rem" iconName="Close"></app-svg>
          </button>
          <a
            [attr.data-qa]="logoButtonId?.getButtonId()"
            [href]="'/' + zone + '/'"
            (click)="navigateHome($event)"
            tabindex="0"
            class="header--logo"
            [ngClass]="{ 'header--logo-small': inScroll }"
          >
            <img
              [alt]="'altText.habaLogo' | cxTranslate"
              [src]="inScroll ? wehrfritzLogoSmallSrc : wehrfritzLogoSrc"
              [width]="inScroll ? wehrfritzLogoSmall.width : wehrfritzLogo.width"
              [height]="inScroll ? wehrfritzLogoSmall.height : wehrfritzLogo.height"
              [ngClass]="{ 'white-logo': inScroll && isShopRelatedPage }"
            />
          </a>
        </div>
      </div>
      <div class="scroll-horizontal-menu" *ngIf="inScroll" [@fadeIn]>
        <app-horizontal-menu
          *ngIf="!isOrderConfirmation && navigationData$ | async as navigation"
          [navigationNodes]="navigationNodes$ | async"
          [quickLinks]="navigation?.items[0]?.fields?.quickCallComponents"
          [scrolledOnShopRelatedPage]="inScroll && isShopRelatedPage"
        ></app-horizontal-menu>
      </div>

      <div
        *ngIf="isDesktop"
        class="header--search d-none col-lg-6 justify-content-center position-unset"
        [ngClass]="!inScroll ? 'd-lg-flex' : ''"
      >
        <app-search-wrapper class="flex-grow-1" [baseId]="baseId"></app-search-wrapper>
      </div>
      <div
        class="position-unset min-width-max-content"
        [ngClass]="{
          'col-6 col-lg-3': !isComponentInitiated || !inScroll,
          'icons-allignment': inScroll,
        }"
      >
        <div class="d-flex justify-content-end">
          <div class="d-flex align-items-center header--icons">
            <ng-container *ngIf="!ociService.isOciSession">
              <div class="search-icon" [ngClass]="inScroll ? 'd-flex' : 'd-none'">
                <app-search-wrapper [asSearchIcon]="true" [baseId]="baseId"></app-search-wrapper>
              </div>
              <app-login [baseId]="baseId"></app-login>

              <app-icon-link-with-count
                [ngClass]="isShopRelatedPage ? '' : 'd-none d-lg-block'"
                [route]="(isLoggedIn ? { cxRoute: 'wishlist' } : { cxRoute: 'login' }) | cxUrl"
                [qaId]="wishlistButtonId?.getButtonId()"
                [quantity]="(totalWishlistItems$ | async) || 0"
                iconName="Heart"
              ></app-icon-link-with-count>
            </ng-container>

            <app-mini-cart [baseQaId]="baseId"></app-mini-cart>

            <a
              *ngIf="!isShopRelatedPage"
              [attr.data-qa]="logoButtonId?.getButtonId()"
              [routerLink]="['shop']"
              tabindex="0"
              class="shop-item d-lg-none"
            >
              Shop
            </a>
          </div>
        </div>
      </div>
      <div #mobileSearchWrapper class="search-wrapper d-lg-none d-flex col-12" *ngIf="!inScroll">
        <app-search-wrapper class="flex-grow-1 mt-6" [baseId]="baseId" />
      </div>
      <div #shopNavWrapper class="col-12" *ngIf="!isDesktop && !sideMenuToggled">
        <app-shop-nav-mobile
          *ngIf="!isOrderConfirmation && navigationData$ | async as navigation"
          [navigationNodes]="navigationNodes$ | async"
          [quickLinks]="navigation?.items[0]?.fields?.quickCallComponents"
          [inScroll]="inScroll"
        ></app-shop-nav-mobile>
      </div>
    </div>
  </div>

  <div class="header--section-navigation container" [@slideUpFade] *ngIf="!inScroll && isDesktop">
    <app-horizontal-menu
      *ngIf="isBrowser && !isOrderConfirmation && navigationData$ | async as navigation"
      [navigationNodes]="navigationNodes$ | async"
      [quickLinks]="navigation?.items[0]?.fields?.quickCallComponents"
    ></app-horizontal-menu>
    <app-ssr-navigation
      *ngIf="!isBrowser && !isOrderConfirmation"
      [navigationNodes]="navigationNodes$ | async"
    ></app-ssr-navigation>
  </div>

  <div
    #sideMenuContainer
    class="p-3 side-menu"
    *ngIf="sideMenuToggled"
    [style.height]="
      'calc(100vh - ' + (inScroll ? mobileTopOffsetInScroll : mobileTopOffset) + 'px)'
    "
  >
    <app-side-menu
      *ngIf="navigationData$ | async as navigation"
      [navigationNodes]="navigationNodes$ | async"
      [quickLinks]="navigation?.items[0]?.fields?.quickCallComponents"
      (closeSearch)="onCloseSearch()"
      (requestScrollTop)="scrollSideMenuToTop()"
    ></app-side-menu>
  </div>
</div>
